import { Component, effect, inject, signal } from '@angular/core';
import { PlayActivityComponent } from './play-activity/play-activity.component';
import { RecommendationsCountComponent } from './recommendations-count/recommendations-count.component';
import { MatSelectModule } from '@angular/material/select';
import { GlobalLoggedInUserStore } from '@r1-compass-library/store/logged-in-user/global-logged-in-user.store';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'r1-compass-app-reporting',
    templateUrl: './reporting.component.html',
    styleUrl: './reporting.component.scss',
    imports: [
        MatSelectModule,
        PlayActivityComponent,
        FormsModule,
        ReactiveFormsModule,
        RecommendationsCountComponent
    ],
})
export class ReportingComponent {
    readonly userStore = inject(GlobalLoggedInUserStore);

    availableDivisionsSignal = this.userStore.usersAvailableDivisions;

    selectedDivisionIds: number[] = [];
    selectedDivisionIdsSignal = signal<number[]>([]);

    constructor() {
        // Always set the currently logged in division as the default selection
        effect(() => {
            const selectedDivisionId = this.userStore.selectedIamDivisionId();
            if (selectedDivisionId) {
                this.selectedDivisionIds = [selectedDivisionId];
                this.selectedDivisionIdsSignal.set(this.selectedDivisionIds);
            }
        });
    }

    public onDivisionDropdownOpenChange(open: boolean) {
        if (!open) {
            this.selectedDivisionIdsSignal.set(this.selectedDivisionIds);
        }
    }
}
